export default "__VITE_ASSET__BmfUjVs3__"